import { useQuery } from '@tanstack/react-query';

import { fetchListingStages } from '@/api/v4/project-listings.api';
import { QueryKey } from '@/config/query-client';
import { getTimeInMs } from '@/helpers/get-time-in-ms';

export const useListingStages = () => {
  const query = useQuery({
    queryKey: [QueryKey.ListingStages],
    queryFn: () => fetchListingStages(),
    gcTime: getTimeInMs(1, 'day'),
    staleTime: getTimeInMs(1, 'day'),
  });

  return {
    listingStages: query.data ?? [],
    ...query,
  };
};
